import { axios } from '@Root/API'

export const getByName = name => {
	return axios.get(`diocese/name/${name}`)
}
